import { createAction } from 'typesafe-actions';

export const spinnerStart = createAction('SHOW_SPINNER')();
export const spinnerStop = createAction('STOP_SPINNER')();
